import * as React from "react";
import { motion } from "framer-motion";
import { ChartData, cTotal, cDelta, cDeath } from "./FullGraph";
import { Line } from "@vx/shape";
import { Text } from "@vx/text";

export interface Props {
  width: number;
  height: number;
  datum: ChartData;
  x: (d: ChartData) => number;
  y1: (d: ChartData) => number;
  y2: (d: ChartData) => number;
  y3: (d: ChartData) => number;
}

const H = 16;
const W = 32;
export default function TimeMarker({ width, height, datum, x, y1, y2, y3 }: Props) {
  const xv = x(datum);
  const y1v = y1(datum);
  const y2v = y2(datum);
  const y3v = y3(datum);

  const _y3v = y3v;
  const _y2v = y3v - y2v > H ? y2v : y3v - H - 1;
  const _y1v = _y2v - y1v > H ? y1v : _y2v - H - 1;

  const flip = xv + W > width;

  return (
    <motion.g
      x={0}
      y={0}
      animate={{
        x: xv
      }}
      transition={{ ease: "easeOut" }}
    >
      <Line
        from={{ x: 0, y: 0 }}
        to={{ x: 0, y: height }}
        stroke="rgba(92, 119, 235, 1.000)"
        strokeWidth={2}
        style={{ pointerEvents: "none" }}
        strokeDasharray="2,2"
      />
      <Dot y={y1v} color={cTotal} />
      <Dot y={y2v} color={cDelta} />
      <Dot y={y3v} color={cDeath} />

      <Value y={_y1v} value={datum.total} flip={flip} />
      <Value y={_y2v} value={datum.delta} flip={flip} />
      <Value y={_y3v} value={datum.deaths} flip={flip} />
    </motion.g>
  );
}

interface DotProps {
  y: number;
  color: string;
}
function Dot({ y, color }: DotProps) {
  return (
    <motion.g
      x={0}
      y={0}
      animate={{
        y
      }}
      transition={{ ease: "easeOut" }}
    >
      <circle
        cx={0}
        cy={1}
        r={4}
        fill="black"
        fillOpacity={0.1}
        stroke="black"
        strokeOpacity={0.1}
        strokeWidth={2}
        style={{ pointerEvents: "none" }}
      />
      <circle cx={0} cy={0} r={4} fill={color} stroke="white" strokeWidth={2} style={{ pointerEvents: "none" }} />
    </motion.g>
  );
}

interface ValueProps {
  y: number;
  value: number;
  flip: boolean;
}
function Value({ y, value, flip }: ValueProps) {
  let x = flip ? W * -1 : 8;
  return (
    <motion.g
      y={8}
      animate={{
        y: y - 8
      }}
      transition={{ ease: "easeOut" }}
    >
      <rect x={x} y={0} width={W} height={H} fill={"#4A5568"} rx={4} opacity={0.8} />
      <Text x={x + W / 2} y={4} width={W} textAnchor="middle" fontSize="10px" verticalAnchor="start" fill="#fff">
        {value}
      </Text>
    </motion.g>
  );
}
